export function formatCNPJ(input: string | undefined) {
  if (input) {
    return input.replace(
      /^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})$/i,
      "$1.$2.$3/$4-$5"
    );
  } else {
    return "";
  }
}

export const mesesExt = [
  "janeiro",
  "fevereiro",
  "março",
  "abril",
  "maio",
  "junho",
  "julho",
  "agosto",
  "setembro",
  "outubro",
  "novembro",
  "dezembro",
];

export const shortMesesExt = [
  "jan",
  "fev",
  "mar",
  "abr",
  "mai",
  "jun",
  "jul",
  "ago",
  "set",
  "out",
  "nov",
  "dez",
];

export function parseRegiao(input: string) {
  const inputUC = input.toUpperCase();

  //Quando faz pesquisa no submercado do CCEE centro-oeste sudeste é o mesmo sub-mercado
  if (inputUC === "CENTRO-OESTE" || inputUC === "CENTROOESTE") {
    return "SUDESTE";
  } else if (inputUC === "NE" || inputUC === "NORDESTE") {
    return "Nordeste";
  } else if (inputUC === "NORTE") {
    return "Norte";
  } else if (inputUC === "SUL") {
    return "Sul";
  } else if (inputUC === "SUDESTE" || inputUC === "SE") {
    return "Sudeste/Centro-Oeste";
  } else {
    return "error";
  }
}

export function capitalize(input: string) {
  const inputUC = input.toLowerCase();
  const firstLetter = inputUC.charAt(0).toUpperCase();
  const wordTail = inputUC.slice(1);
  return (firstLetter + wordTail).replace("-", " ").replace("_", " ");
}

export function convertDate(date: string) {
  return `${new Date(date).toLocaleDateString("pt-br").split(",")[0]}`;
}

export function convertDateHour(date: string) {
  const dateObj = new Date(date);
  const day = String(dateObj.getDate()).padStart(2, "0");
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const year = dateObj.getFullYear();
  const hours = String(dateObj.getHours()).padStart(2, "0");
  const minutes = String(dateObj.getMinutes()).padStart(2, "0");
  return `${day}/${month}/${year} ${hours}:${minutes}`;
}

export function parseBrazilianNumber(raw: unknown): number {
  const value = String(raw).trim();
  if (!/^(\d{1,3}(\.\d{3})+|\d+)(,\d+)?$/.test(value)) return NaN;
  return Number(value.replace(/\./g, "").replace(",", "."));
}

export function maskBrazilianDecimalInput(raw: string): string {
  const digitsAndComma = raw.replace(/[^\d,]/g, "");
  const [integerPart, ...rest] = digitsAndComma.split(",");
  if (rest.length === 0) return integerPart;
  return `${integerPart},${rest.join("")}`;
}

export function formatBrazilianCurrency(value: number): string {
  return value.toLocaleString("pt-BR", {
    style: "currency",
    currency: "BRL",
  });
}

export function formatBrazilianPercent(value: unknown): string {
  const parsed =
    typeof value === "number" ? value : parseBrazilianNumber(value);

  return parsed.toFixed(2).replace(".", ",");
}

export function formatNumberToBrazilCurrency(number: number) {
  const formattedNumber = new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(number);

  return formattedNumber;
}

export function formatCellPhoneNumberToBrazilCurrency(
  phoneNumber: number
): string {
  const phoneConverter = phoneNumber.toString();

  // Formata o número
  const formattedNumber = `+${phoneConverter.slice(
    0,
    2
  )} (${phoneConverter.slice(2, 4)}) ${phoneConverter.slice(
    4,
    9
  )}-${phoneConverter.slice(9)}`;

  return formattedNumber;
}

export function verifyCnpj(cnpj: string, strict = false): boolean {
  const BLACKLIST = new Set([
    "00000000000000",
    "11111111111111",
    "22222222222222",
    "33333333333333",
    "44444444444444",
    "55555555555555",
    "66666666666666",
    "77777777777777",
    "88888888888888",
    "99999999999999",
  ]);

  const STRICT_MASK_REGEX = /^(?:[A-Z0-9]{2}\.[A-Z0-9]{3}\.[A-Z0-9]{3}\/[A-Z0-9]{4}-\d{2}|[A-Z0-9]{12}\d{2})$/i;
  const STRICT_STRIP_REGEX = /[./-]/g;
  const LOOSE_STRIP_REGEX = /[^A-Z0-9]/gi;

  if (typeof cnpj !== "string") return false;

  const normalized = cnpj.toUpperCase();

  if (strict && !STRICT_MASK_REGEX.test(normalized)) {
    return false;
  }

  const stripped = normalized.replace(
    strict ? STRICT_STRIP_REGEX : LOOSE_STRIP_REGEX,
    ""
  );

  if (!stripped || stripped.length !== 14 || BLACKLIST.has(stripped)) {
    return false;
  }

  if (!/^[A-Z0-9]{12}\d{2}$/.test(stripped)) {
    return false;
  }

  const cnpjDigit = (digits: string) => {
    let sum = 0;
    let weight = 2;

    for (let i = digits.length - 1; i >= 0; i--) {
      sum += (digits.charCodeAt(i) - 48) * weight;
      weight = weight === 9 ? 2 : weight + 1;
    }

    const mod = sum % 11;
    return mod < 2 ? 0 : 11 - mod;
  };

  let numbers = stripped.slice(0, 12);
  numbers += cnpjDigit(numbers);
  numbers += cnpjDigit(numbers);

  return numbers.slice(-2) === stripped.slice(-2);
}
